module.exports = __webpack_public_path__ + "static/media/x.81289735.svg";